<template>
	<div v-if="userForm" class="py-8">
		<UserPropertiesForm :form="userForm" @on-save="saveUser" :available-companies="$attrs.user?.companies"/>
	</div>
</template>

<script>
import UserPropertiesForm from "@/Forms/User/UserPropertiesForm.vue";
import { mapStores } from "pinia";
import { useUsersStore } from "@/stores/users.js";

export default {
	name: "UserPropertiesView",
	components: {UserPropertiesForm},
	data() {
		return {
			userForm: undefined,
		}
	},
	computed: {
		...mapStores(useUsersStore)
	},
	methods: {
		async saveUser() {
			try {
				const response = await this.userForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.users.user.properties.user_properties_view.user_saved'),
          life: 3000
        });
				this.$emit('on-save');
				this.$router.replace({ params: {...this.$route.params, user: response.data.id} });
			} catch (error) {
				//
			}
		}
	},
	watch: {
		'$route.params.user': {
			async handler(newValue, oldValue) {
				console.log('here');
				if(newValue){
					if(this.$route.params.user === 'NEW'){
						this.userForm = await this.usersStore.createUser();
					} else {
						this.userForm = await this.usersStore.editUser(this.$route.params.user);
					}
				} else {
					this.userForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>